<template>
  <el-container :class="{ orange_bg: !store.state.isAuthenticated }">
    <el-aside
      class="main-side-menu"
      :style="{ width: isCollapse ? '65px' : '341px' }"
      v-if="store.state.isAuthenticated"
    >
      <Nav />
    </el-aside>

    <el-container v-loading="store.state.isLoading" class="main-container">
      <el-header :class="{ logged_in: store.state.isAuthenticated }">
        <ul>
          <li v-if="store.state.isAuthenticated" class="customer_name">
            {{ store.state.customer_name }}
          </li>
          <li
            v-if="
              store.state.isAuthenticated &&
                store.state.login_type != 'administrator'
            "
          >
            <router-link to="/profile">{{ $t("profile") }}</router-link>
          </li>
          <li v-if="store.state.isAuthenticated">
            <router-link to="/logout">{{ $t("Logout") }}</router-link>
          </li>
          <li>
            <a href="help.pdf" target="_blank">{{ $t("help") }}</a>
          </li>
        </ul>

        <LocaleChanger />
      </el-header>

      <el-main class="main-wrapper" :key="store.state.language">
        <el-divider v-if="store.state.isAuthenticated"></el-divider>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { provide } from "vue";
import store from "@/store";
import Nav from "@/components/nav";
import LocaleChanger from "@/components/locale-changer";
import "primevue/resources/themes/saga-orange/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
require("typeface-prompt");
export default {
  name: "App",

  components: {
    Nav,
    LocaleChanger
  },
  setup() {
    provide("store", store);
  },
  data: () => ({
    store,
    isCollapse: false
  }),
  async mounted() {
    function idleTimer(cb, time) {
      var timeout;

      window.onclick = resetTimer;

      function resetTimer() {
        clearTimeout(timeout);

        timeout = setTimeout(cb, time);
      }

      resetTimer();
    }

    const router = this.$router;

    idleTimer(function() {
      if (!router.currentRoute.value.name.includes("login")) {
        router.push("/logout");
      }
    }, 600000);

    router.push("/cleaning");

    const response = await store.methods.apiRequest("getsessionstatus");

    const res = response.data;

    if (res.errordetails) {
      console.log("error", res.errordetails);
    }

    if (res.logintype) {
      store.methods.setLogin(true);
      store.methods.setCustomerName(res.providername ?? res.mandatename);
      store.methods.setLoginType(res.logintype);

      if ("providermodul" in res)
        store.methods.setProviderModule(res.providermodul);

      if (res.noticesfield) {
        store.methods.setNoticesField(res.noticesfield);
      }

      if (res.logintype == "mandate") {
        if (res.deleteentries) {
          store.methods.setDeleteEntries(res.deleteentries);
        }
        router.push("/cleaning");
      } else if (res.logintype == "administrator") {
        store.methods.setCustomerName("ADMINISTRATOR");
        router.push("/users");
      } else {
        router.push("/announcements");
      }
    }
  },
  methods: {
    switchLanguage: function(lang) {
      store.methods.switchLanguage(lang);
    }
  }
};
</script>

<style lang="scss">
@import "@vueform/multiselect/themes/default.scss";

.el-message {
  font-size: 30px;

  @media screen and(min-width: 1501px) {
    left: 60%;
  }

  .el-message__content {
    font-size: 30px !important;
  }
}

div.multiselect {
  &.is-open {
    border-radius: 21px;

    div.multiselect-input {
      border-color: $gkt-orange;
    }
  }

  .multiselect-option {
    padding: 0 12px;
  }

  .multiselect-placeholder {
    color: #bebebe;
    font-size: 13px;
  }

  div.multiselect-options {
    border-radius: 21px;
    top: 50px;
  }

  div.multiselect-input {
    border-radius: 21px;
    background-color: #ffffff;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    .multiselect-clear {
      border-top-right-radius: 21px;
      border-bottom-right-radius: 21px;
    }
  }
}

.small-rounded-btn {
  display: inline-block;
  width: 38px;
  height: 38px;
  text-align: center;
  border-radius: 38px;
  border: 0;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
  transition: background-color 0.25s ease-in-out;
  line-height: 45px;
  position: relative;
  margin-right: 32px;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }

  &:hover,
  &:focus {
    background-color: lighten($gkt-light-grey, 2);
    transition: background-color 0.25s ease-in-out;
  }

  &::before {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 38px;
    box-shadow: -5px -5px 10px #ffffff;
  }
}

#app {
  height: 100%;

  .el-container {
    height: 100%;
  }
}

.el-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 80px;
  margin-top: 12px;

  ul {
    display: inline-flex;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      color: #ffffff;
      margin-right: 48px;

      a {
        text-decoration: none;
        color: #ffffff;
      }
    }
  }

  &.logged_in {
    .click-lang {
      color: $gkt-orange !important;
    }

    .customer_name {
      color: $gkt-orange;
      font-weight: bold;
      margin-right: 100px;
      text-transform: uppercase;
    }

    a {
      color: $gkt-orange !important;
    }
  }
}

html,
body {
  margin: 0;
  height: 100%;
}

.orange_bg {
  background-color: $gkt-orange;
}

.page-title {
  color: rgba(221, 112, 3, 0.87);
  font-size: 24px;
  margin-bottom: 12px;
}

.intro {
  color: #5a5958;
  font-size: 15px;
  margin-bottom: 24px;
}

.no-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

div.el-divider {
  background-color: rgba(221, 112, 3, 0.87);
  height: 2px;
  margin-top: 0;
}

main.main-wrapper {
  padding-top: 12px;

  @media screen and(max-width: 767px) {
    overflow: hidden;
  }
}

.main-container {
  padding-left: 40px;
  padding-right: 48px;

  @media screen and(max-width: 1500px) {
    padding: 24px;
  }
}

aside.main-side-menu {
  box-shadow: 15px 15px 50px silver;

  @media screen and(max-width: 1500px) {
    width: 87px !important;
    overflow: hidden;
    box-shadow: -10px 15px 25px silver;
  }
}

.el-menu-gkt {
  min-height: 100vh;
}
</style>
